module.exports = __webpack_public_path__ + "static/media/image (11).dc3fda18.jpg";